export const nodeIds = {
    TRIGGER: 'b1a1c1d1-e1f1-41a1-91b1-c1d1e1f1a1b1',
    SCHEDULED_TRIGGER: '65f73c01-931d-448f-ad0e-79fd2da20513',
    GENERATE_REPORT_PERIOD: 'b2a2c2d2-e2f2-42a2-92b2-c2d2e2f2a2b2',
    GENERATE_GOOGLE_ADS_SEGMENT: 'b3a3c3d3-e3f3-43a3-93b3-c3d3e3f3a3b3',
    FETCH_CAMPAIGNS_DATA: 'b5a5c5d5-e5f5-45a5-95b5-c5d5e5f5a5b5',
    AGGREGATE_CAMPAIGNS_DATA: 'b6a6c6d6-e6f6-46a6-96b6-c6d6e6f6a6b6',
    GENERATE_FETCH_KEYWORDS_REQUEST_PAYLOAD: 'b7a7c7d7-e7f7-47a7-97b7-c7d7e7f7a7b7',
    FETCH_KEYWORDS_DATA_FOR_CAMPAIGNS: 'b8a8c8d8-e8f8-48a8-98b8-c8d8e8f8a8b8',
    AGGREGATE_KEYWORDS_DATA: 'b9a9c9d9-e9f9-49a9-99b9-c9d9e9f9a9b9',
    NORMALIZE_DATA: 'c1b1d1e1-f1a1-51b1-11c1-d1e1f1a1b1c1',
    PROCESS_CAMPAIGN_DATA: 'c2b2d2e2-f2a2-52b2-12c2-d2e2f2a2b2c2',
    GENERATE_OVERALL_AI_INSIGHTS: 'd1e1f1a1-b1c1-81d1-41e1-f1a1b1c1d1e1',
    GENERATE_CATEGORY_AI_INSIGHTS: 'd2e2f2a2-b2c2-82d2-42e2-f2a2b2c2d2e2',
    GENERATE_CAMPAIGN_AI_INSIGHTS: 'd3e3f3a3-b3c3-83d3-43e3-f3a3b3c3d3e3',
    PROCESS_OUTPUT: 'd4e4f4a4-b4c4-84d4-44e4-f4a4b4c4d4e4'
};

export const nodes = [
    {
        id: nodeIds.TRIGGER,
        display_name: "Trigger",
        type: "workflow_module",
        action: "manual_trigger",
        credentials: [],
        description: "Manual trigger to start the campaign analysis workflow"
    },
    {
        id: nodeIds.FETCH_CAMPAIGNS_DATA,
        display_name: "Fetch Campaigns Data",
        type: "app_action",
        app: "google_ads",
        action: "get_campaigns",
        credentials: [],
        description: "Retrieve campaign data from Google Ads API"
    },
    {
        id: nodeIds.AGGREGATE_CAMPAIGNS_DATA,
        display_name: "Aggregate Campaigns Data",
        type: "workflow_module",
        action: "aggregate",
        credentials: [],
        description: "Aggregate and consolidate campaign data"
    },
    {
        id: nodeIds.FETCH_KEYWORDS_DATA_FOR_CAMPAIGNS,
        display_name: "Fetch Keywords Data for Campaigns",
        type: "app_action",
        app: "google_ads",
        action: "get_keyword_view_data",
        credentials: [],
        description: "Retrieve keyword performance data from Google Ads"
    },
    {
        id: nodeIds.AGGREGATE_KEYWORDS_DATA,
        display_name: "Aggregate Keywords Data",
        type: "workflow_module",
        action: "aggregate",
        credentials: [],
        description: "Aggregate and consolidate keyword data"
    },
    {
        id: nodeIds.PROCESS_CAMPAIGN_DATA,
        display_name: "Process Campaign Data",
        type: "app_action",
        app: "google_ads_campaign_analyser",
        action: "process_campaign_data",
        credentials: [],
        description: "Process and analyze campaign performance data"
    },
    {
        id: nodeIds.GENERATE_OVERALL_AI_INSIGHTS,
        display_name: "Generate Overall AI Insights",
        type: "app_action",
        app: "google_ads_campaign_analyser",
        action: "generate_overall_ai_insights",
        credentials: [],
        description: "Generate AI-powered insights for overall campaign performance"
    },
]

export const isActionsEnabled = false;